<template>
  <pops :show="popDetail" :title="'病例详情'" @closePop="closePopDetail" :width="'60%'">
    <div class="popScore carsePop">
      <div class="popContent detailCont popTxt">
        <el-row class="row">
          <el-col :span="12">
            <div>
              <span class="label">病例名称：</span>
              <span class="content">{{this.medicDetail.caseName}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <span class="label">病例分类：</span>
              <span class="content">{{typeName}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12">
            <div style="margin-left:25px;">
              <span class="label">性别：</span>
              <span class="content">{{this.medicDetail.caseSex}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="margin-left:25px;">
              <span class="label">年龄：</span>
              <span class="content">{{this.medicDetail.caseAge}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row class="row changeHeight">
          <el-col :span="24">
            <div>
              <span class="label">患者病史：</span>
              <span class="content disContent" style=" line-height:20px;">{{this.medicDetail.history}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row class="row changeHeight">
          <el-col :span="24">
            <div>
              <span class="label">影像所见：</span>
              <span class="content disContent" style=" line-height:20px;">{{this.medicDetail.evidence}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row class="row changeHeight">
          <el-col :span="24">
            <div>
              <span class="label">诊断结果：</span>
              <span class="content disContent" style=" line-height:20px;">{{this.medicDetail.dianogeResult}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row class="row changeHeight">
          <el-col :span="24">
            <div>
              <span class="label">病理结果：</span>
              <span class="content disContent" style=" line-height:20px;">{{this.medicDetail.caseResult}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--确定取消按钮-->
<!--       <div class="btn-box">
        <el-button @click="_savePopDetail" class="save">确定</el-button>
        <el-button @click="_cancel" class="cancel">取消</el-button>
      </div> -->
    </div>
  </pops>
</template>

<script type="text/ecmascript-6">
  import pops from '@/components/common/pops/pop'
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  export default {
    components: {
      pops
    },
    data() {
      return {
        popDetail: false,
        typeName:'',
        medicDetail: []
      }
    },
    watch: {
     
    },
    mounted() {
    },
    methods: {
      openCase(val){
        this.popDetail = true
        let params = {
          id: val
        }
        http.post('/caselib/getCaseDetail.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.medicDetail = res.data.model
            if(this.medicDetail.caseSex === '1'){
              this.medicDetail.caseSex = '男'
            } else if(this.medicDetail.caseSex === '0'){
              this.medicDetail.caseSex = '女'
            }
            if(this.medicDetail.caseAge!==undefined){
              if (this.medicDetail.ageUnit === '4') {
                this.medicDetail.caseAge = this.medicDetail.caseAge + '岁'
              } else if (this.medicDetail.ageUnit === '3') {
                this.medicDetail.caseAge = this.medicDetail.caseAge + '月'
              } else if (this.medicDetail.ageUnit === '2') {
                this.medicDetail.caseAge = this.medicDetail.caseAge + '周'
              } else if(this.medicDetail.ageUnit === '1'){
                this.medicDetail.caseAge = this.medicDetail.caseAge + '天'
              } else if(this.medicDetail.ageUnit === '5'){
                this.medicDetail.caseAge = this.medicDetail.caseAge + '小时'
              }
            } else {
              this.medicDetail.caseAge = ''
            }
            let examinePart = "";
            for (let item of this.medicDetail.catalogList) {
              examinePart +="," + item.catalogname;
              if (examinePart.substr(0,1)==',')
                examinePart=examinePart.substr(1);
            }
            this.typeName = examinePart
          }
        })
      },
      closePopDetail() {
        this.popDetail = false
      },
      _savePopDetail() {
        this.popDetail = false
      },
      _cancel(){
        this.popDetail = false
      }
    },
    created() {
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .btn-box
    text-align: center
    margin: 26px 0
    .save, .cancel
      width: 180px
      height: 35px
      border: none
      color: $button-text-color
    .save
      background: $color-background-hover
      margin-right: 80px
    .commonBtn
      width: 90px
    .cancel
      background: $button-del
  
</style>



// WEBPACK FOOTER //
// casePop.vue?ad5209f6